import { Component } from '@theme/component';
import { formatMoney } from '@theme/money-formatting';

class LumenelleRoutineComponent extends Component {
  requiredRefs = ['submitButton', 'status'];
  #busy = false;

  connectedCallback() {
    super.connectedCallback();
    this.handleChange();
  }

  updatedCallback() {
    super.updatedCallback();
    this.handleChange();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  handleChange() {
    let total = 0;
    let selected = 0;
    for (const card of this.querySelectorAll('[data-routine-card]')) {
      const select = card.querySelector('[data-routine-variant]');
      const checkbox = card.querySelector('[data-routine-check]');
      if (!(select instanceof HTMLSelectElement) || !(checkbox instanceof HTMLInputElement)) continue;
      const option = select.selectedOptions[0];
      checkbox.disabled = !option?.value || option.disabled || this.#busy;
      if (!option?.value || option.disabled) checkbox.checked = false;
      select.disabled = this.#busy;
      const price = card.querySelector('[data-routine-price]');
      if (price && option?.dataset.money) price.textContent = option.dataset.money;
      if (checkbox.checked && option?.value) {
        selected += 1;
        total += Number(option.dataset.price) * (Number(option.dataset.quantity) || 1);
      }
    }
    const button = this.refs.submitButton;
    if (!(button instanceof HTMLButtonElement)) return;
    button.disabled = this.#busy || selected === 0;
    button.textContent = this.#busy
      ? this.dataset.busyText
      : selected === 0
        ? this.dataset.selectText
        : `${this.dataset.addText} - ${formatMoney(total, this.dataset.moneyFormat || '{{amount}}', this.dataset.currency || 'USD')}`;
  }

  /** @param {SubmitEvent} event */
  async handleSubmit(event) {
    event.preventDefault();
    if (this.#busy) return;
    const items = [];
    for (const card of this.querySelectorAll('[data-routine-card]')) {
      const checkbox = card.querySelector('[data-routine-check]');
      const select = card.querySelector('[data-routine-variant]');
      if (!(checkbox instanceof HTMLInputElement) || !checkbox.checked || !(select instanceof HTMLSelectElement)) continue;
      const option = select.selectedOptions[0];
      if (!option?.value || option.disabled) continue;
      items.push({variantId: option.value, quantity: Number(option.dataset.quantity) || 1});
    }
    if (items.length === 0) return;
    const productForm = this.closest('.product-details')?.querySelector(`product-form-component[data-product-id="${this.dataset.productId}"]`);
    const status = this.refs.status;
    this.#busy = true;
    this.setAttribute('aria-busy', 'true');
    status.hidden = true;
    this.handleChange();
    try {
      await customElements.whenDefined('product-form-component');
      if (!productForm?.addItemsToCart) throw new Error('Product form unavailable');
      const result = await productForm.addItemsToCart(items);
      if (result?.detail?.didError) throw new Error('Cart rejected selection');
      for (const checkbox of this.querySelectorAll('[data-routine-check]')) {
        if (checkbox instanceof HTMLInputElement) checkbox.checked = false;
      }
    } catch {
      if (this.isConnected) {
        status.textContent = this.dataset.errorText;
        status.hidden = false;
      }
    } finally {
      this.#busy = false;
      if (this.isConnected) {
        this.removeAttribute('aria-busy');
        this.handleChange();
      }
    }
  }
}

if (!customElements.get('lumenelle-routine-component')) {
  customElements.define('lumenelle-routine-component', LumenelleRoutineComponent);
}
